import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { apiFetch } from '../utils/apiClient';

// API base URL - configurable via environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

function Checkout() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const createCheckoutSession = async () => {
      const searchParams = new URLSearchParams(location.search);
      const plan = searchParams.get('plan');
      const billing = searchParams.get('billing');

      // Validate plan
      if (!plan || (plan !== 'pro' && plan !== 'premium')) {
        setError('Invalid plan selected. Please choose Pro or Premium.');
        setLoading(false);
        return;
      }

      // Validate billing
      if (!billing || (billing !== 'monthly' && billing !== 'yearly')) {
        setError('Invalid billing cycle selected. Please choose monthly or yearly.');
        setLoading(false);
        return;
      }

      try {
        // Map frontend 'premium' to backend 'unlimited'
        const backendPlanType = plan === 'premium' ? 'unlimited' : plan;

        // Build success and cancel URLs
        const successUrl = `${window.location.origin}/billing?checkout=success`;
        const cancelUrl = `${window.location.origin}/pricing?checkout=cancelled`;

        const response = await apiFetch(`${API_BASE_URL}/create-checkout-session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            plan_type: backendPlanType,
            billing_cycle: billing,
            success_url: successUrl,
            cancel_url: cancelUrl,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            typeof errorData.detail === 'string'
              ? errorData.detail
              : JSON.stringify(errorData.detail)
          );
        }

        const data = await response.json();
        
        // Redirect to Stripe checkout
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          throw new Error('No checkout URL returned from server');
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    createCheckoutSession();
  }, [location.search, navigate]);

  return (
    <div className="authenticated-page">
      <div className="authenticated-page-content authenticated-page-content-centered">
        {loading && (
          <div>
            <h2>Creating checkout session...</h2>
            <p>Please wait while we redirect you to secure payment.</p>
          </div>
        )}
        {error && (
          <div className="authenticated-page-content-narrow">
            <h2 className="theme-error">Checkout Error</h2>
            <p className="theme-error" style={{ marginBottom: '1rem' }}>{error}</p>
            <Link to="/pricing" className="checkout-return-link">
              Return to Pricing
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Checkout;
